import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getFileURL, getLocalizedName } from '../../../../helpers';
import Icon from '@projeccions-pdc/react-icon';
import RaisedButton from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { LibraryPicker } from '../../../Library/index';
import DateTimePicker from '../../../Common/DateTimePicker';
import Collections from '../Collections';
import ContentPicker from '../../../Common/ContentPicker';
import Loader from '../../../Common/Loader';
import LocalizedStrings from '../../../Localization/localization';
import ContentService from '../../../../apiclients/ContentService';
import AppContext from '../../../../AppContext';
import languages from '../../../../language-codes.json';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Alert from '@material-ui/lab/Alert';
import './Steps.css';

class FirstStepInternal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPickerOpen: false,
        };
    }

    handleNameFieldChange = (evt) => {
        this.props.onDataChange('name', evt.target.value);
    };

    handleLanguageFieldChange = (evt) => {
        this.props.onDataChange('language', evt.target.value);
    };

    handlePickerResult = (files) => {
        let fileId = files[0].fileId;
        this.props.onDataChange('previewImage', fileId);
        this.setState({ isPickerOpen: false });
    };

    handlePreviewImageFieldClose = () => {
        this.setState({ isPickerOpen: false });
    };

    handlePreviewImageFieldChange = () => {
        this.setState({ isPickerOpen: true });
    };

    handlePreviewImageFieldRemove = () => {
        this.props.onDataChange('previewImage', undefined);
    };

    handleDateFieldChange = (date) => {
        this.props.onDataChange('date', date);
    };

    render() {
        let fieldStyle = {
            marginTop: '10px',
        };
        return (
            <div>
                <div style={fieldStyle}>
                    <TextField
                        fullWidth
                        id="name"
                        label={LocalizedStrings.name}
                        value={this.props.contentData.name ? this.props.contentData.name : ''}
                        onChange={this.handleNameFieldChange}
                        margin="normal"
                    />
                </div>
                <div style={fieldStyle}>
                    <FormControl fullWidth>
                        <InputLabel htmlFor="language">{LocalizedStrings.language}</InputLabel>
                        <Select
                            value={this.props.contentData.language}
                            onChange={this.handleLanguageFieldChange}
                            inputProps={{
                                name: 'language',
                                id: 'language',
                            }}
                        >
                            {languages.map((lang) => {
                                return (
                                    <MenuItem key={lang['alpha2']} value={lang['alpha2']}>
                                        {lang.name}
                                    </MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>
                </div>
                {this.props.modalType === 'mtg' ? (
                    <div style={fieldStyle}>
                        <DateTimePicker
                            label={LocalizedStrings.mtgDate}
                            selected={this.props.contentData.date}
                            onChange={this.handleDateFieldChange}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="LLL"
                            timeCaption="time"
                        />
                    </div>
                ) : (
                    ''
                )}
                <div style={fieldStyle}>
                    {this.props.contentData.previewImage ? (
                        <Chip
                            avatar={<Avatar alt="preview" src={getFileURL(this.props.contentData.previewImage)} />}
                            label={LocalizedStrings.previewImage}
                            onDelete={this.handlePreviewImageFieldRemove}
                        />
                    ) : (
                        <div>
                            {`${LocalizedStrings.previewImage}: `}
                            <Button variant="outlined" onClick={this.handlePreviewImageFieldChange}>
                                {LocalizedStrings.addImage}
                            </Button>
                        </div>
                    )}
                    {/* {this.props.contentData.previewImage ?
                        <img
                            style={{ width: 'auto', height: '50px', verticalAlign: 'middle', margin: '0px 5px' }}
                            alt='preview'
                            src={getFileURL(this.props.contentData.previewImage)} />
                        : ''}
                    <Button variant="outlined" onClick={this.handlePreviewImageFieldChange}>
                        {this.props.contentData.previewImage ? LocalizedStrings.editImage : LocalizedStrings.addImage}
                    </Button>
                    {'  '}
                    {this.props.contentData.previewImage ?
                        <Button variant="outlined" onClick={this.handlePreviewImageFieldRemove}>
                            {LocalizedStrings.removeImage}
                        </Button>
                        : ''} */}

                    {
                        this.state.isPickerOpen && (
                            <Dialog
                                fullScreen={this.props.fullScreen}
                                open={true}
                                fullWidth={true}
                                maxWidth="xl"
                                onClose={this.handlePreviewImageFieldClose}
                            >
                                <DialogTitle style={{ position: 'relative' }}>
                                    {LocalizedStrings.pickPreview}
                                    {'  '}
                                    {this.props.fullScreen && (
                                        <div style={{ position: 'absolute', right: '10px', top: '10px' }}>
                                            <Button onClick={this.handlePreviewImageFieldClose} color="primary">
                                                {LocalizedStrings.close}
                                            </Button>
                                        </div>
                                    )}
                                </DialogTitle>
                                <DialogContent style={{ padding: 0 }}>
                                    <LibraryPicker
                                        pickerPreFilters={{
                                            fileType: 'image',
                                            multipleChoice: false,
                                        }}
                                        onPickFiles={this.handlePickerResult}
                                    />
                                </DialogContent>
                            </Dialog>
                        )
                        // <div style={{ margin: '5px 0px' }}>
                        //     <LibraryPicker
                        //         pickerPreFilters={{
                        //             fileType: 'image',
                        //             multipleChoice: false,
                        //         }}
                        //         onPickFiles={this.handlePickerResult}
                        //     />
                        // </div>
                    }
                </div>
            </div>
        );
    }
}
FirstStepInternal.propTypes = {
    onDataChange: PropTypes.func.isRequired,
    contentData: PropTypes.object.isRequired,
    modalType: PropTypes.string,
    fullScreen: PropTypes.bool.isRequired,
};
const FirstStep = withMobileDialog()(FirstStepInternal);

class ChooseStep extends Component {
    handleChooseChooserChange = (type) => {
        //reset options
        if (type === 'collection') {
            this.props.onDataChange('resources', undefined);
        } else {
            this.props.onDataChange('collection', undefined);
        }
        this.props.onDataChange('contentOrigin', type);
        this.props.next();
    };

    render() {
        return (
            <div style={{ textAlign: 'center' }}>
                <Button variant="outlined" style={{ margin: '15px' }} onClick={() => this.handleChooseChooserChange('collection')}>
                    {LocalizedStrings.chooseCollection}
                </Button>
                {'  '}
                <Button variant="outlined" style={{ margin: '15px' }} onClick={() => this.handleChooseChooserChange('content')}>
                    {LocalizedStrings.createCollection}
                </Button>
            </div>
        );
    }
}
ChooseStep.propTypes = {
    onDataChange: PropTypes.func.isRequired,
    next: PropTypes.func.isRequired,
};

class AddContentMeetingStep extends Component {
    handleOpenContent = (collection) => {
        this.props.onDataChange('collection', collection);
    };

    doNothing = () => {};

    render() {
        if (this.props.contentData.contentOrigin === 'collection') {
            return (
                <div style={{ width: '85vw', textAlign: 'center' }}>
                    <Collections
                        canCreate={false}
                        canEdit={false}
                        selectedCollection={this.props.contentData.collection}
                        onCollectionSelected={this.handleOpenContent}
                        openContent={this.doNothing}
                    />
                    <Alert style={{ marginTop: '1rem' }} severity="warning">
                        {LocalizedStrings.shareLinksNotIncluded}
                    </Alert>
                </div>
            );
        } else {
            return <SecondStep {...this.props} />;
        }
    }
}
AddContentMeetingStep.propTypes = {
    onDataChange: PropTypes.func.isRequired,
    contentData: PropTypes.object.isRequired,
};

class SecondStep extends Component {
    render() {
        return (
            <>
                <ContentPicker
                    notify={this.props.notify}
                    onDataChange={(newRes) => this.props.onDataChange('resources', newRes)}
                    contents={this.props.contentData.resources}
                    disabled={false}
                />
                <Alert style={{ marginTop: '1rem' }} severity="warning">
                    {LocalizedStrings.shareLinksNotIncluded}
                </Alert>
            </>
        );
    }
}
SecondStep.propTypes = {
    onDataChange: PropTypes.func.isRequired,
    contentData: PropTypes.object.isRequired,
    notify: PropTypes.func,
};

class ThirdStep extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    getLanguageName = (langCode) => {
        let found = false;
        let lang;
        for (let i = 0; i < languages.length && !found; i++) {
            let currLang = languages[i];
            if (currLang['alpha2'] === langCode) {
                lang = currLang;
                found = true;
            }
        }
        return lang ? lang.name : undefined;
    };

    render() {
        let language = new AppContext().getLanguage();
        let sectionStyle = {
            margin: '10px 0px',
        };
        return (
            <div>
                <h1>{LocalizedStrings.summary}</h1>
                <div style={sectionStyle}>
                    <b>{`${LocalizedStrings.name}: `}</b>
                    {this.props.contentData.name}
                </div>
                <div style={sectionStyle}>
                    <b>{`${LocalizedStrings.language}: `}</b>
                    {this.getLanguageName(this.props.contentData.language)}
                </div>
                {this.props.modalType && this.props.modalType === 'mtg' ? (
                    <div style={sectionStyle}>
                        <b>{`${LocalizedStrings.mtgDate}: `}</b>
                        {this.props.contentData.date ? this.props.contentData.date.toDate().toLocaleString() : LocalizedStrings.noDefined}
                    </div>
                ) : (
                    ''
                )}
                <div style={sectionStyle}>
                    <b>{`${LocalizedStrings.previewImage}: `}</b>
                    {this.props.contentData.previewImage ? (
                        // <img
                        //     style={{ width: '50px', height: 'auto', verticalAlign: 'middle', margin: '0px 5px' }}
                        //     alt='preview'
                        //     src={getFileURL(this.props.contentData.previewImage)} />
                        <Avatar
                            alt="preview"
                            src={getFileURL(this.props.contentData.previewImage)}
                            style={{
                                display: 'inline-block',
                                verticalAlign: 'middle',
                            }}
                        />
                    ) : (
                        LocalizedStrings.noDefined
                    )}
                </div>
                {this.props.modalType && this.props.modalType === 'mtg' && this.props.contentData.contentOrigin === 'collection' ? (
                    <div style={sectionStyle}>
                        <b>{'Collection: '}</b>
                        {this.props.contentData.collection
                            ? getLocalizedName(language, this.props.contentData.collection.names)
                            : LocalizedStrings.noDefined}
                    </div>
                ) : (
                    <div style={sectionStyle}>
                        <b>{`${LocalizedStrings.resources}: `}</b>
                        {this.props.contentData.resources && this.props.contentData.resources.length > 0 ? (
                            <ContentPicker
                                notify={this.props.notify}
                                language={language}
                                onDataChange={(newRes) => this.props.onDataChange('resources', newRes)}
                                contents={this.props.contentData.resources}
                                disabled={true}
                            />
                        ) : (
                            LocalizedStrings.noDefined
                        )}
                    </div>
                )}
                <Alert style={{ marginTop: '1rem' }} severity="warning">
                    {LocalizedStrings.shareLinksNotIncluded}
                </Alert>
            </div>
        );
    }
}
ThirdStep.propTypes = {
    onDataChange: PropTypes.func.isRequired,
    contentData: PropTypes.object.isRequired,
    notify: PropTypes.func,
    modalType: PropTypes.string,
};

class CreationStep extends Component {
    constructor(props) {
        super(props);
        this.state = {
            create: 'pending',
            sections: 'pending',
            previewImage: 'pending',
            publish: 'pending',
            finish: false,
        };
    }

    async componentDidMount() {
        // Create
        let creationResponse;
        if (this.props.modalType === 'col') {
            creationResponse = await this.processTask('create', async () => {
                let updateResponse = await ContentService.createCollection(this.props.contentData.name, this.props.contentData.language);
                return updateResponse;
            });
        } else {
            creationResponse = await this.processTask('create', async () => {
                let updateResponse = await ContentService.createMeeting(
                    this.props.contentData.name,
                    this.props.contentData.language,
                    this.props.contentData.date.toDate().toISOString()
                );
                return updateResponse;
            });
        }

        let contentId = creationResponse.contentId;
        let version = creationResponse.version;

        // Sections
        await this.processTask('sections', async () => {
            let updateResponse;
            if (this.props.modalType && this.props.modalType === 'mtg' && this.props.contentData.contentOrigin === 'collection') {
                updateResponse = await this.props._MeetingsAndCollectionsController.setContentSectionsFromCollection(
                    contentId,
                    this.props.contentData.language,
                    this.props.contentData,
                    version
                );
            } else {
                updateResponse = await this.props._MeetingsAndCollectionsController.setContentSections(
                    this.props.modalType,
                    contentId,
                    this.props.contentData.language,
                    this.props.contentData,
                    version
                );
            }
            return updateResponse;
        });

        // Set Preview Image
        await this.processTask('previewImage', async () => {
            let updateResponse = await ContentService.setContentPreviewImage(contentId, this.props.contentData.previewImage);
            return updateResponse;
        });

        // Publish
        await this.processTask('publish', async () => {
            let updateResponse = await ContentService.publishResource(contentId);
            return updateResponse;
        });

        this.setState({ finish: true, contentId });
    }

    processTask = async (task, method) => {
        this.setState({ [task]: 'pending' });
        try {
            let response = await method();
            // console.log(task, response);
            if (response === null) {
                this.setState({ [task]: 'error' });
            } else {
                this.setState({ [task]: 'done' });
            }
            return response;
        } catch (err) {
            console.log(err);
            this.setState({ [task]: 'error' });
        }
    };

    loader = () => (
        // <div className='pdc-structure-loader'>
        //     <Icon
        //         name='fa-refresh'
        //         padding={5} />
        // </div>
        <Loader loading={true} padding={5} />
    );

    loaded = () => <Icon name="fa-check" primaryColor={'#45b75e'} padding={5} />;

    error = () => <Icon name="fa-close" primaryColor={'#db3030'} padding={5} />;

    handleFinish = (evt) => {
        this.props.closeModal();
        if (this.state.contentId) {
            this.props.openContent(this.state.contentId, 'm', 'edit', evt);
        }
    };

    getIcon = (step) => {
        if (this.state[step] === 'pending') {
            return this.loader();
        } else if (this.state[step] === 'done') {
            return this.loaded();
        } else {
            return this.error();
        }
    };

    render() {
        return (
            <div>
                <div>
                    <h4>{`${LocalizedStrings.creationProcess}: `}</h4>
                    <div>
                        {this.getIcon('create')}
                        {LocalizedStrings.creating}
                    </div>
                    <div>
                        {this.getIcon('sections')}
                        {LocalizedStrings.composing}
                    </div>
                    <div>
                        {this.getIcon('previewImage')}
                        {LocalizedStrings.preparing}
                    </div>
                    <div>
                        {this.getIcon('publish')}
                        {LocalizedStrings.publishing}
                    </div>
                </div>
                {this.state.finish ? (
                    <div style={{ marginTop: '30px', textAlign: 'right' }}>
                        {this.state.create === 'error' ||
                        this.state.sections === 'error' ||
                        this.state.previewImage === 'error' ||
                        this.state.publish === 'error' ? (
                            <div>{LocalizedStrings.processErrors}</div>
                        ) : (
                            <div>{LocalizedStrings.processSucceed}</div>
                        )}
                        <br />
                        {/* <button onClick={this.props.closeModal}>{'Finish'}</button> */}
                        <RaisedButton
                            label={LocalizedStrings.finish}
                            //primary={true}
                            color="primary"
                            onClick={this.handleFinish}
                        >
                            {LocalizedStrings.finish}
                        </RaisedButton>
                    </div>
                ) : (
                    ''
                )}
            </div>
        );
    }
}
CreationStep.propTypes = {
    contentData: PropTypes.object.isRequired,
    _MeetingsAndCollectionsController: PropTypes.object.isRequired,
    closeModal: PropTypes.func.isRequired,
    modalType: PropTypes.string,
    openContent: PropTypes.func.isRequired,
};

export { FirstStep, ChooseStep, AddContentMeetingStep, SecondStep, ThirdStep, CreationStep };
